import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 35770 18526"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:518.407}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970065678976">
        <path
          d="m17228 17335 8414-7357c433-379 433-1052 0-1429l-8414-7356c-370-324-141-934 350-934h7504c401 0 790 146 1092 410l9012 7880c433 377 433 1051 0 1429l-9012 7879c-303 264-691 410-1092 410h-7504c-491 0-720-609-350-932zM12260 602c-390 389-390 1020 0 1408 389 390 1020 390 1409 0 389-388 389-1019 0-1408-388-389-1020-389-1409 0zM14913 3255c-390 389-390 1019 0 1408 388 390 1019 390 1409 0 389-389 389-1019 0-1408-390-390-1021-390-1409 0z"
          className="fill stroke1"
          style={{
            strokeWidth: 518.407,
          }}
        />
        <path
          d="M17564 5906c-389 390-389 1020 0 1409 389 390 1020 390 1409 0 390-389 390-1019 0-1409-388-389-1020-389-1409 0zM20217 8558c-389 390-389 1021 0 1410s1020 389 1409 0 389-1020 0-1410c-389-388-1020-388-1409 0zM12260 17925c-390-389-390-1020 0-1410 389-388 1020-388 1409 0 389 390 389 1021 0 1410-388 389-1020 389-1409 0zM14913 15272c-390-389-390-1019 0-1409 388-389 1019-389 1409 0 389 390 389 1020 0 1409-390 390-1021 390-1409 0zM17564 12621c-389-390-389-1020 0-1410 389-389 1020-389 1409 0 390 390 390 1020 0 1410-388 388-1020 388-1409 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 518.407,
          }}

        />
        <path
          d="M20217 9968c-389-389-389-1020 0-1410 389-388 1020-388 1409 0 389 390 389 1021 0 1410s-1020 389-1409 0zM6405 602c-389 389-389 1020 0 1408 390 390 1021 390 1409 0 390-388 390-1019 0-1408-388-389-1019-389-1409 0zM9058 3255c-389 389-389 1019 0 1408 389 390 1020 390 1409 0 389-389 389-1019 0-1408-389-390-1020-390-1409 0zM11710 5906c-389 390-389 1020 0 1409 389 390 1020 390 1409 0 390-389 390-1019 0-1409-389-389-1020-389-1409 0zM14362 8558c-389 390-389 1021 0 1410 390 389 1021 389 1410 0s389-1020 0-1410c-389-388-1020-388-1410 0zM6405 17925c-389-389-389-1020 0-1410 390-388 1021-388 1409 0 390 390 390 1021 0 1410-388 389-1019 389-1409 0zM9058 15272c-389-389-389-1019 0-1409 389-389 1020-389 1409 0 389 390 389 1020 0 1409-389 390-1020 390-1409 0zM11710 12621c-389-390-389-1020 0-1410 389-389 1020-389 1409 0 390 390 390 1020 0 1410-389 388-1020 388-1409 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 518.407,
          }}

        />
        <path
          d="M14362 9968c-389-389-389-1020 0-1410 390-388 1021-388 1410 0 389 390 389 1021 0 1410s-1020 389-1410 0zM551 602c-389 389-389 1020 0 1408 389 390 1020 390 1410 0 388-388 388-1019 0-1408-390-389-1021-389-1410 0zM3203 3255c-389 389-389 1019 0 1408 390 390 1020 390 1409 0 390-389 390-1019 0-1408-389-390-1019-390-1409 0zM5856 5906c-389 390-389 1020 0 1409 389 390 1020 390 1409 0 389-389 389-1019 0-1409-389-389-1020-389-1409 0zM8508 8558c-389 390-389 1021 0 1410s1020 389 1409 0 389-1020 0-1410c-389-388-1020-388-1409 0zM551 17925c-389-389-389-1020 0-1410 389-388 1020-388 1410 0 388 390 388 1021 0 1410-390 389-1021 389-1410 0zM3203 15272c-389-389-389-1019 0-1409 390-389 1020-389 1409 0 390 390 390 1020 0 1409-389 390-1019 390-1409 0zM5856 12621c-389-390-389-1020 0-1410 389-389 1020-389 1409 0 389 390 389 1020 0 1410-389 388-1020 388-1409 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 518.407,
          }}

        />
        <path
          d="M8508 9968c-389-389-389-1020 0-1410 389-388 1020-388 1409 0 389 390 389 1021 0 1410s-1020 389-1409 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 518.407,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
